import React from "react";
import { useNavigate } from "react-router-dom";
import { Page } from "../../components";
import LogoutButton from "../../components/LogoutButton";
import OperatingCostsTab from "./OperatingCostsTab";

const CostsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Page>
      <div
        style={{
          width: "100%",
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 16px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <h1 style={{ fontSize: "clamp(28px, 5vw, 40px)", margin: 0, fontWeight: 600 }}>
            Software Costs
          </h1>
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <button
              onClick={() => navigate("/")}
              style={{
                padding: "8px 16px",
                borderRadius: 6,
                border: "none",
                background: "#6b7280",
                color: "#fff",
                fontSize: 14,
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Back to Home
            </button>
            <LogoutButton />
          </div>
        </div>

        <OperatingCostsTab />
      </div>
    </Page>
  );
};

export default CostsPage;
